import MyaxilocSettingList from '@/components/MyaxilocSetting/MyaxilocSettingList'
import MyaxilocSettingForm from '@/components/MyaxilocSetting/MyaxilocSettingForm'

let MyaxilocSettingRouter = [{
  path: '/myaxiloc_setting',
  name: 'MyaxilocSettingList',
  component: MyaxilocSettingList,
  meta: {
    title: 'Paramètres',
    requiresAuth: true,
    authorizations: ['myaxiloc-setting_index', 'desktop_access']
  }
}, {
  path: '/myaxiloc_setting/new',
  name: 'MyaxilocSettingNew',
  component: MyaxilocSettingForm,
  meta: {
    title: 'Nouveau paramètre',
    requiresAuth: true,
    authorizations: ['myaxiloc-setting_new', 'desktop_access']
  }
}, {
  path: '/myaxiloc_setting/:id/edit',
  name: 'MyaxilocSettingEdit',
  component: MyaxilocSettingForm,
  meta: {
    title: 'Modifier un paramètre',
    requiresAuth: true,
    authorizations: ['myaxiloc-setting_edit', 'desktop_access']
  }
}]

export default MyaxilocSettingRouter



// WEBPACK FOOTER //
// ./src/components/MyaxilocSetting/router.js